import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Divider,
  makeStyles
} from '@material-ui/core';
import { UserModel } from '../../UsersTable';
import { SelectUser } from '../../Check/common/SelectUser';

interface SearchByEmailModal extends DialogProps {
  onRequestClose: (userId: number) => void,
  onUserSelected: () => void
}

const useStyle = makeStyles((theme) => ({
  contentSize: {
    minWidth: '50vh',
    minHeight: '6vh'
  }
}));

export const SearchByEmail = (props: SearchByEmailModal) => {
  const classes = useStyle();
  const [user, setUser] = useState<UserModel | null>(null);

  const validate = () => {
    if (user)
      props.onRequestClose(user.id);
    else
      props.onRequestClose(-1);
  }

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth={false}>
      <DialogTitle>
        Recherche par email
      </DialogTitle>
      <Divider />
      <DialogContent>
        <div className={classes.contentSize}>
          <SelectUser onUserSelected={(user: UserModel | null) => setUser(user)} default={user} displayHelper={false} label="Adresse e-mail de l'utilisateur cible"/>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={validate}>Valider</Button>
      </DialogActions>
    </Dialog>
  )
}